/**
 * TrXL Shop - Analytics Tracking
 * Sendet Events an /api/analytics/track. DSGVO-konform: nur nach Cookie-Consent.
 */

const API = process.env.REACT_APP_BACKEND_URL || '';
const CONSENT_KEY = 'trxl_cookie_consent';
const SESSION_KEY = 'trxl_analytics_sid';

function hasConsent() {
  try {
    const v = localStorage.getItem(CONSENT_KEY);
    // accept any truthy "granted/all/yes/true" value; default block
    return !!v && /^(granted|all|yes|true|accepted|1)$/i.test(v);
  } catch { return false; }
}

function getOrCreateSessionId() {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = (crypto.randomUUID && crypto.randomUUID()) ||
        ('s_' + Math.random().toString(36).slice(2) + Date.now().toString(36));
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch {
    return 's_' + Date.now();
  }
}

function getUserEmail() {
  try {
    const token = localStorage.getItem('trxl_token');
    if (!token) return '';
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.email || '';
  } catch { return ''; }
}

let _lastUrl = '';
let _suppressUntil = 0;

export function trackEvent(type, payload = {}) {
  if (!hasConsent()) return;
  if (Date.now() < _suppressUntil) return;
  try {
    const body = {
      session_id: getOrCreateSessionId(),
      type,
      url: window.location.pathname + window.location.search,
      referrer: document.referrer || '',
      user_email: payload.user_email || getUserEmail(),
      payload,
      user_agent: navigator.userAgent.substring(0, 250),
      screen_w: window.innerWidth,
      screen_h: window.innerHeight,
    };
    fetch(`${API}/api/analytics/track`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      keepalive: true,
    }).catch(() => {
      // Fail silently. If we get a network burst of fails, suppress 60s
      _suppressUntil = Date.now() + 60000;
    });
  } catch { /* silent */ }
}

export function trackPageView() {
  const url = window.location.pathname + window.location.search;
  if (url === _lastUrl) return;
  _lastUrl = url;
  trackEvent('page_view', { title: document.title });
}

let _installed = false;
export function installAnalytics() {
  if (_installed || typeof window === 'undefined') return;
  _installed = true;
  // Initial page view (delayed so consent banner can set localStorage)
  setTimeout(() => trackPageView(), 800);
  // Pick up first PV when user grants consent later
  window.addEventListener('trxl-consent-granted', () => {
    _lastUrl = ''; // force re-track of current URL
    setTimeout(trackPageView, 100);
  });
  // Track route changes via history API (covers SPA navigation)
  const origPush = history.pushState;
  const origReplace = history.replaceState;
  history.pushState = function (...a) { origPush.apply(this, a); setTimeout(trackPageView, 0); };
  history.replaceState = function (...a) { origReplace.apply(this, a); setTimeout(trackPageView, 0); };
  window.addEventListener('popstate', () => setTimeout(trackPageView, 0));
}
